'use strict';
// Cart and checkout use native Shopify forms and work without JavaScript.
function syncVariant(section) {
  const select = section.querySelector('[data-variant-select]');
  const option = select?.selectedOptions[0];
  if (!option) return;
  section.querySelector('[data-variant-price]').textContent = option.dataset.price;
  const compare = section.querySelector('[data-variant-compare]');
  compare.textContent = option.dataset.compare || '';
  compare.hidden = !option.dataset.compare;
  const button = section.querySelector('[data-add-button]');
  const prelaunch = button.dataset.prelaunch === 'true';
  const available = option.dataset.available === 'true';
  button.disabled = prelaunch || !available;
  if (!prelaunch) button.textContent = available ? button.dataset.addLabel : button.dataset.soldoutLabel;
  const image = section.querySelector('#ProductMainImage');
  if (image && option.dataset.image) {
    image.src = option.dataset.image;
    image.removeAttribute('srcset');
  }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
}
document.addEventListener('change', event => {
  if (event.target.matches('[data-variant-select]')) syncVariant(event.target.closest('[data-product-section]'));
});
